// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import VueI18n from 'vue-i18n'
import VueAnalytics from 'vue-analytics'

import { store } from './store'
import colors from 'vuetify/es5/util/colors'
import translations from './locales'
import config from './config'

import 'ol/ol.css'
import 'vuetify/dist/vuetify.css'
import "vue-material-design-icons/styles.css"

import VectorPolygonIcon from 'vue-material-design-icons/vector-polygon.vue'
import VectorPointIcon from 'vue-material-design-icons/vector-point.vue'
import VectorRectangleIcon from 'vue-material-design-icons/vector-rectangle.vue'
import BufferIcon from 'vue-material-design-icons/adjust.vue'

import App from './App'

Vue.component('vector-point-icon', VectorPointIcon)
Vue.component('vector-polygon-icon', VectorPolygonIcon)
Vue.component('vector-rectangle-icon', VectorRectangleIcon)
Vue.component('buffer-icon', BufferIcon)

Vue.use(VueI18n)

Vue.use(VueAnalytics, {
  id: config.googleAnalytics
})

Vue.use(Vuetify, {
  theme: {
    primary: colors.green.base,
    secondary: colors.green.lighten2,
    warning: colors.orange.darken3,
    accent: colors.green.darken4,
    error: colors.red.accent3
  }
})


Vue.config.productionTip = false


const i18n = new VueI18n({
  locale: config.locales[0].key, // set locale
  messages: translations, // set locale messages
})

// import AppLayerswitcher from '@/components/LayerSwitcher/LayerSwitcher'
// import AppLayerswitcherLayer from '@/components/LayerSwitcher/LayerSwitcherLayer'
// import AppLayerSwitcherLayerGroup from '@/components/LayerSwitcher/LayerSwitcherLayerGroup'

// Los declaramos globalmente
// Si no LayerSwitcherLayer y LayerSwitcherLayerGroup no podría usarse recursivamente
// Vue.component('app-layerswitcher', AppLayerswitcher)
// Vue.component('app-layerswitcher-layer', AppLayerswitcherLayer)
// Vue.component('app-layerswitcher-layer-group', AppLayerSwitcherLayerGroup)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  store,
  i18n,
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js